import { identity } from "lodash";
import { Field } from "react-final-form";
import { Descendant, Editor, Transforms } from "slate";

import { FormattedTextEditor, IVariableSelectParams } from "components/rich-editor/formatted-text-editor";
import { RichTextVariables } from "components/rich-editor/plugins/constants";
import { VariableElement } from "components/rich-editor/types";
import { EventPlace, trackEngagement } from "helpers/analytics";
import { compose, requiredMustacheVariable } from "utils/validators";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const Content = () => (
  <Field<Descendant[]>
    name="appearance.contentBody.value.html"
    withDebounce
    parse={
      // this ensures react-final-form never sets value to "undefined"
      // https://github.com/final-form/react-final-form/issues/130#issuecomment-425482365
      identity
    }
    validate={compose(requiredMustacheVariable("Add required <b>message</b> variable", "message.html"))}
    render={FormattedTextEditor}
    // plugins added to the editor
    variablesPlugin
    handleVariableSelect={(editor: Editor) =>
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      ({ label, content }: IVariableSelectParams) => {
        const variable: VariableElement = {
          type: "htmlSnippet",
          label,
          content,
          children: [{ text: "" }],
        };
        Transforms.insertNodes(editor, variable);
        Transforms.move(editor);
        trackEngagement("Visual template editor: Content add variable from list", EventPlace.Settings, {
          variableAdded: label,
        });
      }}
    variablesPluginOptions={[
      RichTextVariables.Message,
      RichTextVariables.RequesterName,
      RichTextVariables.ShortID,
      RichTextVariables.AgentName,
      RichTextVariables.Subject,
      RichTextVariables.PeopleInTheLoop,
    ]}
    linksPlugin
    richTextPlugin
    // customizing the richTextPlugin
    withBold
    withItalic
    withUnderline
    withStrikethrough
  />
);
